import * as React from 'react'
import Title from './title'
import SubTitle from './subTitle'
import Tags from './tags'

const SectionTitle = ({
  title,
  subtitle,
  subtitle2,
  tags,
  isLarger = false,
  id = null,
  style = 'black',
}) => (
  <section className="max-w-6xl mx-auto text-center my-24 px-12 sm:px-6" id={id}>
    <Title isLarger={isLarger}>{title}</Title>
    {subtitle && !subtitle2 && <SubTitle isLarger={isLarger}>{subtitle}</SubTitle>}
    {subtitle && subtitle2 && (
      <SubTitle>
        {subtitle}
        <br />
        {subtitle2}
      </SubTitle>
    )}
    {tags && (
      <Tags
        tags={tags}
        justify="justify-center"
        className="max-w-2xl mx-auto"
        style={style}
        size={`lg`}
      />
    )}
  </section>
)

export default SectionTitle
